import React, { useState, useRef, useEffect } from "react";
import { useSpring, animated } from "@react-spring/web";
import { Box, Button } from "grommet";
import { FormDown, FormUp } from "grommet-icons";
import "./FadeAccordion.css";

export const FadedAccordion = ({ children, previewHeight = 120 }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [fullHeight, setFullHeight] = useState(0);
	const contentRef = useRef(null);

	useEffect(() => {
		const observer = new ResizeObserver(() => {
			if (!contentRef.current) return;

			const rect = contentRef.current.getBoundingClientRect();

			setFullHeight(rect.height);
		});

		if (contentRef.current) {
			observer.observe(contentRef.current);
		}

		return () => observer.disconnect();
	}, [children])

	const styles = useSpring({
		height: isOpen ? fullHeight : previewHeight,
		config: { tension: 220, friction: 24 },
		position: 'relative',
		overflow: 'hidden'
	});

	return (
		<Box style={{ cursor: 'pointer' }} onClick={() => setIsOpen((prev) => !prev)} focusIndicator={false}>

			<animated.div style={styles}>
				<Box ref={contentRef}>
					{children}
				</Box>

				{!isOpen && (
					<Box className="fade-overlay" />
				)}
			</animated.div>

			{(
				<Button
					className="show-btn"
					label={isOpen ? 'Show Less' : 'Show More'}
					icon={isOpen ? <FormUp /> : <FormDown />}
					size="small"
					plain
					fill="horizontal"
					justify="center"
					focusIndicator={false}
				/>
			)}
		</Box>
	);
};
